import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { MouseEvent } from "react";

import { AutocompleteItem } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/AutocompleteItem/autocompleteItem";
import { useResults } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/context/results.context";
import { removeRecentSearchesItem } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/RecentSearches/recentSearches.source";
import { RECENT_SEARCHES_SOURCE_ID } from "@/components/Search/SearchBar/config/searchBar.config";
import { useSearchBarContext } from "@/components/Search/SearchBar/context/searchBar.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const Item = ({ className }: Props) => {
    const { items } = useResults(RECENT_SEARCHES_SOURCE_ID);
    const { autocompleteState, autocompleteActions } = useSearchBarContext();
    const { index } = useMapped();

    const item = items[index];

    const { t } = useGranite();

    const handleOnRemoveClick = (event: MouseEvent) => {
        event.stopPropagation();
        removeRecentSearchesItem(item.label);
        autocompleteActions?.refresh();
    };

    return (
        <AutocompleteItem
            query={item.label}
            className={cn(
                "tw:justify-between tw:flex tw:rounded-sm",
                className
            )}
            itemId={item.__autocomplete_id}
            autocompleteState={autocompleteState}
            autocompleteActions={autocompleteActions}
            getRedirectUrl={() => item.redirectUrl}
        >
            <div className={cn("tw:flex")}>
                <div>
                    <i className={cn("las la-redo-alt", "tw:pr-2 tw:mt-1")} />
                </div>
                {item.label}
            </div>
            <button
                type={"button"}
                className={cn("tw:text-black tw:bg-transparent tw:border-none")}
                onClick={handleOnRemoveClick}
                aria-label={t("accessibility.searchBox.recentSerach")}
            >
                <i className={cn("las la-times")} />
            </button>
        </AutocompleteItem>
    );
};
